export const Question = () => {
  return (
    <svg width="30" height="31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 29.5c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14z"
        stroke="#333"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m13.357 19.77-.024-4.168 1.221-.047c1.033-.015 1.878-.304 2.535-.866.658-.578.986-1.358.986-2.342 0-.89-.313-1.623-.939-2.201-.61-.593-1.408-.89-2.394-.89-.72 0-1.354.172-1.902.515-.532.328-.892.742-1.08 1.241L10 10.474c.313-.874.876-1.585 1.69-2.131.83-.562 1.847-.843 3.052-.843 1.033 0 1.94.21 2.723.632.782.406 1.4.976 1.854 1.71.454.733.681 1.569.681 2.505 0 .89-.203 1.678-.61 2.365a4.528 4.528 0 0 1-1.643 1.663c-.705.405-1.526.648-2.465.726v2.669h-1.925zm.962 4.73c-.375 0-.688-.125-.939-.375a1.24 1.24 0 0 1-.375-.913c0-.375.125-.687.375-.936.25-.25.564-.375.94-.375.375 0 .68.125.915.375.25.25.375.561.375.936 0 .36-.125.664-.375.913-.235.25-.54.375-.916.375z"
        fill="currentColor"
      />
    </svg>
  )
}
